import React, { useState, useEffect } from 'react';
import './Home.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ProductHighlight from './ProductHighlight';
import { Link } from 'react-router-dom';

function Home() {
    const partnerLogos = [
        '/images/lightbits-logo.png',
        '/images/Netris-logo.png',
        '/images/Tigera-logo.png',
        '/images/Canonical-logo.png',
        'images/govexai.png',
    ];
    const partnerLinks = [
        'https://www.lightbitslabs.com/',
        'https://www.netris.io/',
        'https://www.tigera.io/',
        'https://canonical.com/',
        'https://govexai.com/'
    ];
    const intervalTime = 2000;

    const [activeIndexes, setActiveIndexes] = useState([0, 1, 2, 3]);

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndexes(prevIndexes => {
                const nextIndexes = prevIndexes.map(index => (index + 1) % partnerLogos.length);
                return nextIndexes;
            });
        }, intervalTime);

        return () => clearInterval(interval);
    }, []);

    function getPartnerLink(index) {
        return partnerLinks[index];
    }

    return (
        <>
            <noscript>
                <div className="home-section">
                    <div className="home-content">
                        <div className="home-text">
                            <h1>The Future Doesn't Belong to VMware or Nutanix<br />It Belongs to You</h1>
                            <p>We deliver Federal-grade, open-source infrastructure platforms that puts control back in your hands.</p>
                            <a href="/products" className="explore-button">Learn More</a>
                        </div>
                    </div>
                </div>
            </noscript>
            <section className="home-section">
                <div className="home-content">
                    {/* <img
                        src="/images/Eupraxia_X_transparent.png"
                        alt="Eupraxia Labs Logo"
                        className="eupraxia-logo"
                    /> */}
                    <div className="home-text">
                        <h1>The Future Doesn't Belong to VMware or Nutanix<br />It Belongs to You</h1>
                        <p>We deliver Federal-grade, open-source infrastructure platforms that puts control back in your hands.</p>
                        <div className="cta-group">
                            <Link to="/products">
                                <button className="explore-button">Learn More</button>
                            </Link>
                            <Link to="/contact">
                                <button className="explore-button">Get a Demo</button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="value-pills">
                    <div className="pill">
                        <svg className="pill-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                        <span>Seamless VMware to OpenStack Migration</span>
                    </div>
                    <div className="pill">
                        <svg className="pill-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 11c0-3.86-3.14-7-7-7S-2 7.14-2 11h14zm0 0c0 3.86 3.14 7 7 7s7-3.14 7-7h-14z" />
                        </svg>
                        <span>Cost-Effective On-Prem IaaS with VitroAI™</span>
                    </div>
                    <div className="pill">
                        <svg className="pill-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <span>Scalable Control for Day 2 Operations</span>
                    </div>
                </div>
                <div className="product-highlight-section">
                    <ProductHighlight />
                </div>
                <div className="our-partners-section">
                    <h2 className="our-partners-title">Our Partners</h2>
                    <Slider
                        className="partner-logos"
                        infinite={true}
                        autoplay={true}
                        autoplaySpeed={intervalTime}
                        slidesToShow={window.innerWidth <= 768 ? 3 : 3}
                        slidesToScroll={1}
                    >
                        {partnerLogos.map((logo, index) => (
                            <div key={index}>
                                <a href={getPartnerLink(index)} target="_blank" rel="noopener noreferrer">
                                    <img src={logo} alt={`Partner Logo ${index}`} className="partner-logo" />
                                </a>
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>
        </>
    );
}

export default Home;